module.exports = __webpack_public_path__ + "img/UTPIUT-9.6c5993c1.jpg";